import { render, staticRenderFns } from "./BAutocomplete.vue?vue&type=template&id=01599b29"
import script from "./BAutocomplete.vue?vue&type=script&lang=js"
export * from "./BAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports